/**
 * Units badge: native Kaching price per tray / cans per tray.
 * pricing() returns major units; variants-changed event amounts are minor units.
 * Events only schedule reads. A collection-break form quantity counts the base
 * product, not the entire bundle; never use it to derive the per-can price.
 */
(() => {
  'use strict';
  if (window.__c2o3UnitsLiveLoaded) return;
  window.__c2o3UnitsLoaded = true;
  window.__c2o3UnitsLiveLoaded = true;

  function recompute() {
    document.querySelectorAll('product-info').forEach((info) => {
      const widget = info.querySelector('kaching-bundles-block');
      let pricing;
      if (widget) {
        try { pricing = widget.pricing?.(); } catch { return; }
        if (!pricing || !widget.querySelector('.kaching-bundles__block--loaded')) return;
      }
      info.querySelectorAll('[data-c2o3-units][data-live="true"]').forEach((badge) => {
        if (badge.closest('.product-card, .resource-card')) return;
        const units = Number(badge.dataset.unitsPerPack);
        const trayPrice = widget ? pricing.discountedPricePerItem?.amount : Number(badge.dataset.unitPriceAmount);
        if (!(units > 0) || !Number.isFinite(trayPrice) || trayPrice < 0) return;
        let money;
        try {
          money = new Intl.NumberFormat(badge.dataset.locale || undefined, {
            style: 'currency', currency: badge.dataset.currency,
          }).format(trayPrice / units);
        } catch { return; }
        const text = money + (badge.dataset.suffix ? ' ' + badge.dataset.suffix : '');
        if (badge.textContent !== text) badge.textContent = text;
      });
    });
  }

  function init() {
    let frame = 0;
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; recompute(); });
    };
    // Survives replacement of a whole product-info in the editor or on Home.
    new MutationObserver((records) => {
      if (records.some((record) => {
        const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        return target?.closest('product-info') || [...record.addedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE && (node.matches('product-info') || node.querySelector('product-info'))
        );
      })) schedule();
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    ['variants-changed', 'items-changed', 'kaching-bundles-block-loaded', 'shopify:section:load'].forEach((name) => {
      document.addEventListener(name, schedule, true);
    });
    recompute();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
